import { userSignOut } from "actions/Auth";
import React from "react";
import { connect } from "react-redux";
import logo from "../../assets/images/uptin-white.svg";

class UserInfo extends React.Component {
  state = {
    anchorEl: null,
    open: false,
    firstname: "",
    lastname: "",
  };

  handleClick = (event) => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    this.setState({
      firstname: localStorage.getItem("firstname"),
      lastname: localStorage.getItem("lastname"),
    });
  }

  render() {
    return (
      <div
        className="d-flex flex-column align-items-center"
        style={{ width: this.props.width, margin: this.props.margin }}
      >
        <img src={logo} alt="Uptin Logo" style={{ margin: "20%" }} />
      </div>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings;
  return { locale };
};
export default connect(mapStateToProps, { userSignOut })(UserInfo);
